import React from 'react';
import { toast } from 'react-toastify';
import NotificationToast from '@Components/NotificationToast/NotificationToast';
import NotificationsApi from '@Data/notifications/Api';
import { getNotificationSeverity } from '@Data/notifications/Helpers';
import { NotificationType } from '@Data/notifications/Interfaces';
import Styles from './Notification.scss';

export function warn(message: string) {
    _runToast(message, 'warning');
}

export function error(message: string) {
    _runToast(message, 'error');
}

export function info(message: string) {
    _runToast(message, 'info');
}

export function success(message: string) {
    _runToast(message, 'success');
}

const _createToastId = (severity: string): string => {
    const rdm = Math.random().toString(16);
    return `${severity}_${rdm}`;
};

const _runToast = (message: string, severity: string) => {
    const id = _createToastId(severity);
    NotificationsApi.addNotification(
        message,
        getNotificationSeverity(severity),
        NotificationType.STATIC,
        id
    );

    const newToast = (
        <NotificationToast message={message} severity={severity} toastId={id} />
    );

    toast(newToast, {
        toastId: id,
        bodyClassName: Styles.noPad,
        className: Styles.noPad,
        closeButton: false,
        progressClassName: `Toastify__progress-bar--${severity}`,
    });
};
